import React from 'react';
import { cn } from '../../lib/cn';

export function StepIndicator({ steps, currentStep }) {
  return (
    <div className="mb-6 flex items-center justify-center gap-2 sm:gap-4">
      {steps.map((step, i) => {
        const num = i + 1;
        const active = num === currentStep;
        const done = num < currentStep;
        return (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center gap-1">
              <div
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full text-xs font-bold transition-colors',
                  done && 'bg-brand-accent text-brand-dark',
                  active && 'bg-brand-dark text-white ring-2 ring-brand-accent ring-offset-2',
                  !done && !active && 'bg-brand-dark/10 text-brand-earth',
                )}
              >
                {done ? '✓' : num}
              </div>
              <span className={cn('hidden text-xs font-medium sm:block', active ? 'text-brand-dark' : 'text-brand-earth')}>
                {step}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className={cn('h-0.5 w-6 sm:w-12', done ? 'bg-brand-accent' : 'bg-brand-dark/10')} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
